if (!window.__mtScriptsCargado) {
  window.__mtScriptsCargado = true;
  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initMarquee();
    initCifras();
    initCuentaAtras();
    initPopup();
    initCopiar();
  });
}

function initReveal() {
  var items = document.querySelectorAll('.mt-reveal');
  if (!items.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    items.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = entry.target.getAttribute('data-mt-delay') || 0;
          setTimeout(function () { entry.target.classList.add('mt-visible'); }, Number(delay));
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  items.forEach(function (el) { observer.observe(el); });
}

function initMarquee() {
  document.querySelectorAll('[data-mt-marquee]').forEach(function (wrap) {
    var track = wrap.querySelector('.mt-marquee-track');
    if (!track) return;
    var speed = Number(wrap.getAttribute('data-mt-speed')) || 30;
    track.innerHTML += track.innerHTML;
    track.style.animationDuration = speed + 's';
  });
}

function initCifras() {
  var cifras = document.querySelectorAll('.mt-cifra[data-target]');
  if (!cifras.length) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = Number(el.getAttribute('data-target')) || 0;
        observer.unobserve(el);
        if (reduced) { el.textContent = target; return; }
        var start = null;
        var duration = 1400;
        function step(ts) {
          if (!start) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = Math.round(eased * target);
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    },
    { threshold: 0.5 }
  );
  cifras.forEach(function (el) { observer.observe(el); });
}

function initCuentaAtras() {
  var bloques = document.querySelectorAll('[data-mt-countdown]');
  if (!bloques.length) return;

  function actualizar(bloque) {
    var objetivo = new Date(bloque.getAttribute('data-mt-countdown')).getTime();
    var ahora = Date.now();
    var restante = objetivo - ahora;
    var d = bloque.querySelector('[data-mt-cd-d]');
    var h = bloque.querySelector('[data-mt-cd-h]');
    var m = bloque.querySelector('[data-mt-cd-m]');
    var s = bloque.querySelector('[data-mt-cd-s]');
    if (restante <= 0) {
      if (d) d.textContent = '00';
      if (h) h.textContent = '00';
      if (m) m.textContent = '00';
      if (s) s.textContent = '00';
      bloque.classList.add('mt-cd-terminado');
      if (bloque.hasAttribute('data-mt-recargar') && !bloque.__recarga) {
        bloque.__recarga = true;
        try {
          var clave = 'mt-drop-recarga';
          var ultima = Number(sessionStorage.getItem(clave) || 0);
          if (Date.now() - ultima > 60000) {
            sessionStorage.setItem(clave, String(Date.now()));
            setTimeout(function () { location.reload(); }, 1500);
          }
        } catch (e) {}
      }
      return false;
    }
    var totalSeg = Math.floor(restante / 1000);
    var dias = Math.floor(totalSeg / 86400);
    var horas = Math.floor((totalSeg % 86400) / 3600);
    var mins = Math.floor((totalSeg % 3600) / 60);
    var segs = totalSeg % 60;
    if (d) d.textContent = String(dias).padStart(2, '0');
    if (h) h.textContent = String(horas).padStart(2, '0');
    if (m) m.textContent = String(mins).padStart(2, '0');
    if (s) s.textContent = String(segs).padStart(2, '0');
    return true;
  }

  bloques.forEach(function (bloque) { actualizar(bloque); });
  setInterval(function () {
    bloques.forEach(function (bloque) { actualizar(bloque); });
  }, 1000);
}

function initPopup() {
  var popup = document.querySelector('[data-mt-popup]');
  if (!popup) return;
  var storageKey = popup.getAttribute('data-mt-popup-key') || 'mt-popup-visto';
  var horasValidez = Number(popup.getAttribute('data-mt-popup-horas')) || 24;
  var forzar = !!popup.querySelector('[data-mt-popup-forzar]');
  var claveRegistro = popup.getAttribute('data-mt-popup-registro') || 'mt-popup-registrado';
  try {
    if (popup.querySelector('[data-mt-popup-registrado]')) { localStorage.setItem(claveRegistro, '1'); popup.classList.add('mt-popup--registrado'); }
  } catch (e) {}
  var visto = localStorage.getItem(storageKey);
  var yaVisto = false;
  try { if (!forzar && localStorage.getItem(claveRegistro)) yaVisto = true; } catch (e) {}
  if (visto) {
    var visible = Number(visto);
    if (!isNaN(visible) && Date.now() - visible < horasValidez * 3600 * 1000) yaVisto = true;
  }

  function reproducir() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    popup.querySelectorAll('video').forEach(function (v) {
      var p = v.play();
      if (p && p.catch) p.catch(function () {
        var otra = function () { var q = v.play(); if (q && q.catch) q.catch(function () {}); };
        ['pointerdown', 'keydown', 'scroll'].forEach(function (ev) { document.addEventListener(ev, otra, { once: true, passive: true }); });
      });
    });
  }
  function pausar() {
    popup.querySelectorAll('video').forEach(function (v) { v.pause(); });
  }

  function cerrar() {
    pausar();
    popup.classList.remove('mt-popup--abierto');
    document.body.classList.remove('mt-popup-abierto-body');
    localStorage.setItem(storageKey, String(Date.now()));
  }

  popup.querySelectorAll('[data-mt-popup-cerrar]').forEach(function (btn) {
    btn.addEventListener('click', cerrar);
  });
  popup.addEventListener('click', function (e) {
    if (e.target === popup) cerrar();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') cerrar();
  });

  if (!yaVisto || forzar) {
    var retraso = forzar ? 200 : (Number(popup.getAttribute('data-mt-popup-retraso')) || 900);
    setTimeout(function () {
      popup.classList.add('mt-popup--abierto');
      document.body.classList.add('mt-popup-abierto-body');
      reproducir();
    }, retraso);
  }
}

function initCopiar() {
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-mt-copiar]') : null;
    if (!b) return;
    var texto = b.getAttribute('data-mt-copiar');
    function hecho() {
      var l = b.querySelector('[data-mt-copiar-label]');
      if (!l) return;
      var original = l.getAttribute('data-original') || l.textContent;
      l.setAttribute('data-original', original);
      l.textContent = '¡Copiado!';
      setTimeout(function () { l.textContent = original; }, 1600);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(texto).then(hecho, hecho);
    } else {
      var t = document.createElement('textarea');
      t.value = texto;
      document.body.appendChild(t);
      t.select();
      try { document.execCommand('copy'); } catch (err) {}
      document.body.removeChild(t);
      hecho();
    }
  });
}
